import { Host, h, Fragment } from '@stencil/core';
export class AibaQuizMulitple {
  constructor() {
    this.renderQuizQuestions = () => {
      return (h(Fragment, null, this.questionsData.map((item, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
        return (h("div", { class: "single-screen-question", "data-index": index, key: item.data.questionId }, h("aiba-quiz-question", { data: item === null || item === void 0 ? void 0 : item.data, classes: item === null || item === void 0 ? void 0 : item.classes, index: Number(index), total: this.questionsData.length, handlers: this.handlers }), h("aiba-quiz-option", { type: (_b = (_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.answers) === null || _b === void 0 ? void 0 : _b.type, options: (_d = (_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.answers) === null || _d === void 0 ? void 0 : _d.data, optionsEventData: (_g = (_f = (_e = item === null || item === void 0 ? void 0 : item.data) === null || _e === void 0 ? void 0 : _e.answers) === null || _f === void 0 ? void 0 : _f.events) === null || _g === void 0 ? void 0 : _g.data, selectedOptions: item.selectedQuestions, maxSelection: (_j = (_h = item === null || item === void 0 ? void 0 : item.data) === null || _h === void 0 ? void 0 : _h.answers) === null || _j === void 0 ? void 0 : _j.maxSelection, handlers: this.handlers, optionClasses: "quiz-input-container", variant: (_l = (_k = item === null || item === void 0 ? void 0 : item.data) === null || _k === void 0 ? void 0 : _k.answers) === null || _l === void 0 ? void 0 : _l.variant, questionId: (_m = item.data) === null || _m === void 0 ? void 0 : _m.questionId, hideNextButton: 'none', placeholder: ((_p = (_o = item === null || item === void 0 ? void 0 : item.data) === null || _o === void 0 ? void 0 : _o.answers) === null || _p === void 0 ? void 0 : _p.placeholder) ? (_r = (_q = item === null || item === void 0 ? void 0 : item.data) === null || _q === void 0 ? void 0 : _q.answers) === null || _r === void 0 ? void 0 : _r.placeholder : '', data: (_s = item === null || item === void 0 ? void 0 : item.data) === null || _s === void 0 ? void 0 : _s.data, loading: this.loading, total: this.totalQuestions }), this.error && this.error[(_t = item.data) === null || _t === void 0 ? void 0 : _t.questionId] && (h("aiba-label", { classes: ((_v = (_u = this.data) === null || _u === void 0 ? void 0 : _u.error) === null || _v === void 0 ? void 0 : _v.errorLabelClasses) ? (_x = (_w = this.data) === null || _w === void 0 ? void 0 : _w.error) === null || _x === void 0 ? void 0 : _x.errorLabelClasses : ' quizerror', styles: (_z = (_y = this.data) === null || _y === void 0 ? void 0 : _y.error) === null || _z === void 0 ? void 0 : _z.errorStyles, tag: "span", _id: "quizerror", text: ((_0 = item === null || item === void 0 ? void 0 : item.data) === null || _0 === void 0 ? void 0 : _0.questionMandatory) ? (_1 = item === null || item === void 0 ? void 0 : item.data) === null || _1 === void 0 ? void 0 : _1.questionMandatory : this.error[(_2 = item.data) === null || _2 === void 0 ? void 0 : _2.questionId] })), this.customError && this.customError[(_3 = item.data) === null || _3 === void 0 ? void 0 : _3.questionId] && (h("aiba-label", { classes: ((_5 = (_4 = this.data) === null || _4 === void 0 ? void 0 : _4.error) === null || _5 === void 0 ? void 0 : _5.errorLabelClasses) ? (_7 = (_6 = this.data) === null || _6 === void 0 ? void 0 : _6.error) === null || _7 === void 0 ? void 0 : _7.errorLabelClasses : ' quizerror', tag: "span", _id: "custom-quizerror", text: this.customError[(_8 = item.data) === null || _8 === void 0 ? void 0 : _8.questionId] ? this.customError[(_9 = item.data) === null || _9 === void 0 ? void 0 : _9.questionId] : (_10 = item === null || item === void 0 ? void 0 : item.data) === null || _10 === void 0 ? void 0 : _10.questionMandatory })), this.loadingLabel && this.loadingLabel[(_11 = item.data) === null || _11 === void 0 ? void 0 : _11.questionId] && (h("aiba-label", { classes: 'quizloadingLabel', tag: "span", _id: "quizloadingLabel", text: ((_12 = item === null || item === void 0 ? void 0 : item.data) === null || _12 === void 0 ? void 0 : _12.loadingLabel) ? (_13 = item === null || item === void 0 ? void 0 : item.data) === null || _13 === void 0 ? void 0 : _13.loadingLabel : this.loadingLabel[(_14 = item.data) === null || _14 === void 0 ? void 0 : _14.questionId] }))));
      })));
    };
    this.data = undefined;
    this.handlers = undefined;
    this.selectedOptions = undefined;
    this.selectedOptionsWithId = undefined;
    this.renderLeftHalf = false;
    this.enableNextButtonDisabled = false;
    this.totalQuestions = undefined;
    this.quizPlainIndex = undefined;
    this.index = undefined;
    this.groupIndex = undefined;
    this.totalGroups = undefined;
    this.enableMutlipleGroups = false;
    this.state = undefined;
    this.answers = undefined;
    this.error = {};
    this.customError = {};
    this.loadingLabel = {};
    this.quizScreenLoading = false;
    this.questionsData = [];
    this.reRender = undefined;
    this.renderAlert = undefined;
    this.loading = undefined;
    this.nextButtonDisabled = true;
  }
  watchPropHandler(newValue, oldValue) {
    if (this.enableMutlipleGroups) {
      const result = JSON.stringify(newValue) === JSON.stringify(oldValue);
      if (!result) {
        this.loadQuestionsData();
        this.reRender = !this.reRender;
      }
    }
  }
  enableError(event) {
    (event === null || event === void 0 ? void 0 : event.detail) && (this.error[event === null || event === void 0 ? void 0 : event.detail] = true);
    this.reRender = !this.reRender;
  }
  customErrorMessage(event) {
    var _a;
    (event === null || event === void 0 ? void 0 : event.detail) && ((_a = event === null || event === void 0 ? void 0 : event.detail) === null || _a === void 0 ? void 0 : _a.questionId) && (this.customError[event === null || event === void 0 ? void 0 : event.detail.questionId] = event === null || event === void 0 ? void 0 : event.detail.message);
    this.reRender = !this.reRender;
  }
  toggleNextButtonDisable(event) {
    if (event['detail'] && typeof event['detail']['nextButtonDisabled'] === 'boolean') {
      this.nextButtonDisabled = event['detail']['nextButtonDisabled'];
      this.reRender = !this.reRender;
    }
  }
  disableError(event) {
    let updatedError = Object.assign({}, this.error);
    updatedError[event === null || event === void 0 ? void 0 : event.detail] && delete updatedError[event === null || event === void 0 ? void 0 : event.detail];
    this.error = updatedError;
    this.loadQuestionsData();
  }
  toggleLoading(event) {
    let loaderName = event['detail']['loaderName'];
    let value = event['detail']['value'];
    this[loaderName] = value;
    if (event['detail']['loadingLabel']) {
      this.loadingLabel = event['detail']['loadingLabel'];
    }
  }
  toggleAlert(event) {
    this.renderAlert = event['detail']['renderAlert'];
  }
  async componentWillLoad() {
    await this.loadQuestionsData();
  }
  async componentDidUpdate() {
    if (this.handlers && this.handlers.handleQuizMultipleDidUpdate) {
      await this.handlers.handleQuizMultipleDidUpdate();
    }
  }
  async componentDidLoad() {
    if (this.handlers && this.handlers.handleQuizMultipleDidLoad) {
      await this.handlers.handleQuizMultipleDidLoad();
    }
  }
  async loadQuestionsData() {
    var _a;
    if (this.data && this.data.questions) {
      const questionsData = await Promise.all(this.data.questions.map(async (item) => {
        var _a;
        const selectedQuestions = await this.getselectedOptions((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.questionId);
        return Object.assign(Object.assign({}, item), { selectedQuestions });
      }));
      if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.loadDynamicQuestions)) {
        this.questionsData = await (this === null || this === void 0 ? void 0 : this.handlers.loadDynamicQuestions(questionsData));
      }
      else {
        this.questionsData = [...questionsData];
      }
    }
  }
  async getselectedOptions(questionId) {
    var _a, _b;
    if (this.handlers && ((_a = this === null || this === void 0 ? void 0 : this.handlers) === null || _a === void 0 ? void 0 : _a.selectedOptions)) {
      let selectedOptions = await ((_b = this === null || this === void 0 ? void 0 : this.handlers) === null || _b === void 0 ? void 0 : _b.selectedOptions(questionId));
      return selectedOptions ? selectedOptions : [];
    }
    return [];
  }
  handleOptionSelect(event) {
    this.handlers && this.handlers.handleOptionSelect && this.handlers.handleOptionSelect(event);
  }
  handleAnalyzeQuestionClick(event) {
    this.handlers && this.handlers.handleAnalyzeQuestionClick && this.handlers.handleAnalyzeQuestionClick(event);
  }
  handleNextQuestionClick(event) {
    this.handlers && this.handlers.handleNextQuestionClick && this.handlers.handleNextQuestionClick(event);
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92, _93, _94, _95, _96, _97;
    if (typeof this.data === 'string') {
      this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.renderLeftHalf && (h("div", { class: "quiz-left-half" }, this.data &&
      this.data.elements &&
      this.data.elements.map((element) => {
        if (element.name === 'image' && element['_id'] === 'banner-image') {
          return h("img", Object.assign({}, element['data'], { src: this.data.images['left-half-banner-image'] }));
        }
      }))), h("div", { ref: el => (this.parentRef = el), class: "quiz-wrapper-div" }, this.data &&
      this.data.elements &&
      this.data.elements.map((element) => {
        if (element.name === 'aiba-progress-bar') {
          return h("aiba-progress-bar", Object.assign({}, element['data']));
        }
        if (element.name === 'aiba-progress-dots') {
          return h("aiba-progress-dots", { total: Number(this.totalGroups), index: Number(this.groupIndex), handlers: this.handlers });
        }
        if (element.name === 'aiba-label' && element.data.tag === 'p' && element.data._id === 'group-counter') {
          return (h("aiba-label", Object.assign({}, element['data'], { text: `${element.data.prefix} ${this.groupIndex}${element.data.suffix}${this.totalGroups} ${element.data.endingPhrase ? element.data.endingPhrase : ''}` })));
        }
        if (element.name === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element.name === 'aiba-button')
          return (h("aiba-button", Object.assign({}, element['data'], { handleClick: event => this.handlers && this.handlers.handlePrevQuestionClick && this.handlers.handlePrevQuestionClick(event) })));
      }), this.renderLeftHalf ? h("div", { class: `questions-scrollable-wrapper active-group-${this.groupIndex}` }, this.renderQuizQuestions()) : this.renderQuizQuestions(), this.renderAlert && h("aiba-alert-with-index", { handlers: this.handlers }), this.data && ((_a = this.data) === null || _a === void 0 ? void 0 : _a.prev) && ((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.prev) === null || _c === void 0 ? void 0 : _c.data) ? (h("div", { class: `quiz-button-container ${this.renderAlert ? 'alert' : ''}` }, h("aiba-button", Object.assign({ handleClick: event => this.handlers && this.handlers.handlePrevQuestionClick && this.handlers.handlePrevQuestionClick(event) }, (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.prev) === null || _e === void 0 ? void 0 : _e.data, { arialabel: ((_h = (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.prev) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.title) ? (_l = (_k = (_j = this.data) === null || _j === void 0 ? void 0 : _j.prev) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.title : (_p = (_o = (_m = this.data) === null || _m === void 0 ? void 0 : _m.prev) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.arialabel, disabled: (_s = (_r = (_q = this.data) === null || _q === void 0 ? void 0 : _q.prev) === null || _r === void 0 ? void 0 : _r.data) === null || _s === void 0 ? void 0 : _s.disabled })), this.enableMutlipleGroups ? (this.data.analyze && Number(this === null || this === void 0 ? void 0 : this.totalQuestions) === Number(this === null || this === void 0 ? void 0 : this.quizPlainIndex) ? (h("aiba-button", Object.assign({ handleClick: event => this.handleAnalyzeQuestionClick(event) }, (_u = (_t = this.data) === null || _t === void 0 ? void 0 : _t.analyze) === null || _u === void 0 ? void 0 : _u.data, { value: (_x = (_w = (_v = this.data) === null || _v === void 0 ? void 0 : _v.analyze) === null || _w === void 0 ? void 0 : _w.data) === null || _x === void 0 ? void 0 : _x.value, arialabel: (_0 = (_z = (_y = this.data) === null || _y === void 0 ? void 0 : _y.analyze) === null || _z === void 0 ? void 0 : _z.data) === null || _0 === void 0 ? void 0 : _0.title, disabled: this.enableNextButtonDisabled ? this.nextButtonDisabled : (_3 = (_2 = (_1 = this.data) === null || _1 === void 0 ? void 0 : _1.analyze) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.disabled, classes: ((_6 = (_5 = (_4 = this.data) === null || _4 === void 0 ? void 0 : _4.analyze) === null || _5 === void 0 ? void 0 : _5.data) === null || _6 === void 0 ? void 0 : _6.classes) ? (_9 = (_8 = (_7 = this.data) === null || _7 === void 0 ? void 0 : _7.analyze) === null || _8 === void 0 ? void 0 : _8.data) === null || _9 === void 0 ? void 0 : _9.classes : ' quiz-button' }))) : (h("aiba-button", Object.assign({ handleClick: event => this.handleNextQuestionClick(event) }, (_11 = (_10 = this.data) === null || _10 === void 0 ? void 0 : _10.next) === null || _11 === void 0 ? void 0 : _11.data, { value: (_14 = (_13 = (_12 = this.data) === null || _12 === void 0 ? void 0 : _12.next) === null || _13 === void 0 ? void 0 : _13.data) === null || _14 === void 0 ? void 0 : _14.value, classes: ((_17 = (_16 = (_15 = this.data) === null || _15 === void 0 ? void 0 : _15.next) === null || _16 === void 0 ? void 0 : _16.data) === null || _17 === void 0 ? void 0 : _17.classes) ? (_20 = (_19 = (_18 = this.data) === null || _18 === void 0 ? void 0 : _18.next) === null || _19 === void 0 ? void 0 : _19.data) === null || _20 === void 0 ? void 0 : _20.classes : ' quiz-button', arialabel: (_23 = (_22 = (_21 = this.data) === null || _21 === void 0 ? void 0 : _21.next) === null || _22 === void 0 ? void 0 : _22.data) === null || _23 === void 0 ? void 0 : _23.title, disabled: this.enableNextButtonDisabled ? this.nextButtonDisabled : (_26 = (_25 = (_24 = this.data) === null || _24 === void 0 ? void 0 : _24.next) === null || _25 === void 0 ? void 0 : _25.data) === null || _26 === void 0 ? void 0 : _26.disabled })))) : (h("aiba-button", Object.assign({ handleClick: event => this.handleAnalyzeQuestionClick(event) }, (_28 = (_27 = this.data) === null || _27 === void 0 ? void 0 : _27.analyze) === null || _28 === void 0 ? void 0 : _28.data, { styles: (_31 = (_30 = (_29 = this.data) === null || _29 === void 0 ? void 0 : _29.analyze) === null || _30 === void 0 ? void 0 : _30.data) === null || _31 === void 0 ? void 0 : _31.styles, textOnly: (_34 = (_33 = (_32 = this.data) === null || _32 === void 0 ? void 0 : _32.analyze) === null || _33 === void 0 ? void 0 : _33.data) === null || _34 === void 0 ? void 0 : _34.textOnly, value: (_37 = (_36 = (_35 = this.data) === null || _35 === void 0 ? void 0 : _35.analyze) === null || _36 === void 0 ? void 0 : _36.data) === null || _37 === void 0 ? void 0 : _37.title, variant: (_40 = (_39 = (_38 = this.data) === null || _38 === void 0 ? void 0 : _38.analyze) === null || _39 === void 0 ? void 0 : _39.data) === null || _40 === void 0 ? void 0 : _40.variant, upperCase: (_43 = (_42 = (_41 = this.data) === null || _41 === void 0 ? void 0 : _41.analyze) === null || _42 === void 0 ? void 0 : _42.data) === null || _43 === void 0 ? void 0 : _43.upperCase, path: (_46 = (_45 = (_44 = this.data) === null || _44 === void 0 ? void 0 : _44.analyze) === null || _45 === void 0 ? void 0 : _45.data) === null || _46 === void 0 ? void 0 : _46.path, pathWithHover: (_49 = (_48 = (_47 = this.data) === null || _47 === void 0 ? void 0 : _47.analyze) === null || _48 === void 0 ? void 0 : _48.data) === null || _49 === void 0 ? void 0 : _49.pathWithHover, arialabel: (_52 = (_51 = (_50 = this.data) === null || _50 === void 0 ? void 0 : _50.analyze) === null || _51 === void 0 ? void 0 : _51.data) === null || _52 === void 0 ? void 0 : _52.title, disabled: (_55 = (_54 = (_53 = this.data) === null || _53 === void 0 ? void 0 : _53.prev) === null || _54 === void 0 ? void 0 : _54.data) === null || _55 === void 0 ? void 0 : _55.disabled, classes: ((_58 = (_57 = (_56 = this.data) === null || _56 === void 0 ? void 0 : _56.analyze) === null || _57 === void 0 ? void 0 : _57.data) === null || _58 === void 0 ? void 0 : _58.classes) ? (_61 = (_60 = (_59 = this.data) === null || _59 === void 0 ? void 0 : _59.analyze) === null || _60 === void 0 ? void 0 : _60.data) === null || _61 === void 0 ? void 0 : _61.classes : ' quiz-button' }))))) : (h("aiba-button", Object.assign({ handleClick: event => this.handleAnalyzeQuestionClick(event) }, (_63 = (_62 = this.data) === null || _62 === void 0 ? void 0 : _62.analyze) === null || _63 === void 0 ? void 0 : _63.data, { styles: (_66 = (_65 = (_64 = this.data) === null || _64 === void 0 ? void 0 : _64.analyze) === null || _65 === void 0 ? void 0 : _65.data) === null || _66 === void 0 ? void 0 : _66.styles, textOnly: (_69 = (_68 = (_67 = this.data) === null || _67 === void 0 ? void 0 : _67.analyze) === null || _68 === void 0 ? void 0 : _68.data) === null || _69 === void 0 ? void 0 : _69.textOnly, value: (_72 = (_71 = (_70 = this.data) === null || _70 === void 0 ? void 0 : _70.analyze) === null || _71 === void 0 ? void 0 : _71.data) === null || _72 === void 0 ? void 0 : _72.title, variant: (_75 = (_74 = (_73 = this.data) === null || _73 === void 0 ? void 0 : _73.analyze) === null || _74 === void 0 ? void 0 : _74.data) === null || _75 === void 0 ? void 0 : _75.variant, upperCase: (_78 = (_77 = (_76 = this.data) === null || _76 === void 0 ? void 0 : _76.analyze) === null || _77 === void 0 ? void 0 : _77.data) === null || _78 === void 0 ? void 0 : _78.upperCase, path: (_81 = (_80 = (_79 = this.data) === null || _79 === void 0 ? void 0 : _79.analyze) === null || _80 === void 0 ? void 0 : _80.data) === null || _81 === void 0 ? void 0 : _81.path, pathWithHover: (_84 = (_83 = (_82 = this.data) === null || _82 === void 0 ? void 0 : _82.analyze) === null || _83 === void 0 ? void 0 : _83.data) === null || _84 === void 0 ? void 0 : _84.pathWithHover, arialabel: (_87 = (_86 = (_85 = this.data) === null || _85 === void 0 ? void 0 : _85.analyze) === null || _86 === void 0 ? void 0 : _86.data) === null || _87 === void 0 ? void 0 : _87.title, disabled: (_90 = (_89 = (_88 = this.data) === null || _88 === void 0 ? void 0 : _88.analyze) === null || _89 === void 0 ? void 0 : _89.data) === null || _90 === void 0 ? void 0 : _90.disabled, classes: ((_93 = (_92 = (_91 = this.data) === null || _91 === void 0 ? void 0 : _91.analyze) === null || _92 === void 0 ? void 0 : _92.data) === null || _93 === void 0 ? void 0 : _93.classes) ? (_96 = (_95 = (_94 = this.data) === null || _94 === void 0 ? void 0 : _94.analyze) === null || _95 === void 0 ? void 0 : _95.data) === null || _96 === void 0 ? void 0 : _96.classes : ' quiz-button' })))), ((_97 = this.data) === null || _97 === void 0 ? void 0 : _97.modals) && (h("div", { class: "modals-wrapper" }, this.data.modals['elements'] &&
      this.data.modals['elements'].map((modalElem) => {
        if (modalElem && modalElem['name'] === 'aiba-loading-modal') {
          return (this.quizScreenLoading && (h("aiba-modal", Object.assign({}, modalElem['data']), h("aiba-spinner", Object.assign({}, Object.assign({}, modalElem['spinner']))))));
        }
      })))));
  }
  static get is() { return "aiba-quiz-multiple"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quiz.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quiz.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "selectedOptions": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-options",
        "reflect": false
      },
      "selectedOptionsWithId": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "selected-options-with-id",
        "reflect": false
      },
      "renderLeftHalf": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-left-half",
        "reflect": false,
        "defaultValue": "false"
      },
      "enableNextButtonDisabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-next-button-disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "totalQuestions": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total-questions",
        "reflect": false
      },
      "quizPlainIndex": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "quiz-plain-index",
        "reflect": false
      },
      "index": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "index",
        "reflect": false
      },
      "groupIndex": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "group-index",
        "reflect": false
      },
      "totalGroups": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total-groups",
        "reflect": false
      },
      "enableMutlipleGroups": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-mutliple-groups",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "state": {},
      "answers": {},
      "error": {},
      "customError": {},
      "loadingLabel": {},
      "quizScreenLoading": {},
      "questionsData": {},
      "reRender": {},
      "renderAlert": {},
      "loading": {},
      "nextButtonDisabled": {}
    };
  }
  static get watchers() {
    return [{
        "propName": "data",
        "methodName": "watchPropHandler"
      }];
  }
  static get listeners() {
    return [{
        "name": "event-options-error",
        "method": "enableError",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "event-options-custom-error",
        "method": "customErrorMessage",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "event-toggle-next-button-disabled",
        "method": "toggleNextButtonDisable",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "event-clear-error",
        "method": "disableError",
        "target": "window",
        "capture": true,
        "passive": false
      }, {
        "name": "toggle-quiz-screen-loading",
        "method": "toggleLoading",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "toggle-alert-in-quiz",
        "method": "toggleAlert",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-quiz-multiple.js.map
